export function LandingWorkflow() {
  return (
    <section id="workflow" style={{ padding: "var(--lp-sec-y) 0" }}>
      <div
        className="lp-container stack-md"
        style={{ display: "grid", gridTemplateColumns: ".9fr 1.1fr", gap: 52, alignItems: "center" }}
      >
        <div>
          <span className="lp-eyebrow" data-reveal>The magic</span>
          <h2 className="lp-h1" data-reveal style={{ marginTop: 12 }}>
            Held, then <em>confirmed.</em>
          </h2>
          <p className="lp-lede" data-reveal style={{ marginTop: 22, maxWidth: "42ch" }}>
            When a guest picks a slot, BunnyCal holds it while they finish - no double-books, no
            awkward emails. The moment they're done, it settles into a confirmed meeting on both
            calendars.
          </p>
        </div>

        <div
          data-reveal
          style={{
            background: "var(--lp-cream)",
            border: "1px solid var(--lp-border)",
            borderRadius: "var(--lp-radius-lg)",
            boxShadow: "var(--lp-shadow-card)",
            padding: 32,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ fontFamily: "var(--lp-mono)", fontSize: 11, letterSpacing: ".1em", textTransform: "uppercase", color: "var(--lp-plum-300)" }}>
              Thu · May 21
            </div>
            {/* The pill's holding→confirmed state is scrubbed by scroll position. */}
            <span
              className="lp-morph-pill"
              data-reveal="none"
              data-morph
            >
              <svg width="20" height="20" viewBox="0 0 18 18" fill="none">
                <path
                  d="M5 9.2 8 11.6 12.5 6.6"
                  stroke="var(--lp-plum-700)"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ strokeDasharray: 20, strokeDashoffset: 20 }}
                />
              </svg>
              <span className="lp-morph-label" data-morph-label>
                Holding · 9:32 left
              </span>
            </span>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {["2:00 pm", "2:30 pm", "3:00 pm"].map((t) => (
                <span
                  key={t}
                  style={{ fontFamily: "var(--lp-mono)", fontSize: 12, padding: "6px 11px", borderRadius: "var(--lp-radius-pill)", background: "var(--lp-ivory-2)", color: "var(--lp-plum-400)" }}
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
